export default __webpack_public_path__ + "static/media/custodies-icon.58fe5354.svg";